import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';
import { usePasswordResetRequestMutation } from '@/queries/auth/usePasswordResetRequestMutation';

const EMAIL_RE = /^[A-Za-z0-9+_.-]+@[A-Za-z0-9.-]+$/;

export default function ForgotPasswordForm({ onCancel, onSent }) {
  const resetRequest = usePasswordResetRequestMutation();
  const [sent, setSent] = React.useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm({
    defaultValues: { email: '' },
    mode: 'onSubmit',
  });

  const onSubmit = async (values) => {
    try {
      await resetRequest.mutateAsync(values.email);
      setSent(true);
      onSent?.();
    } catch {
      /* notification from mutation */
    }
  };

  if (sent) {
    return (
      <div className="text-left">
        <p className="mb-4 text-sm leading-relaxed text-[var(--muted-foreground)]">
          If an account exists for that email, we sent a confirmation code.
          Enter it on the reset password page to choose a new password.
        </p>
        <div className="flex flex-col gap-3 sm:flex-row">
          <Link
            to="/reset-password"
            className="inline-flex min-h-11 flex-1 items-center justify-center gap-2 rounded-[var(--bethere-radius-md)] bg-[var(--bethere-accent)] px-6 font-bold text-[#121212] shadow-sm transition hover:bg-[var(--bethere-secondary)]"
          >
            Reset password
          </Link>
          <button
            type="button"
            className="inline-flex min-h-11 flex-1 items-center justify-center rounded-[var(--bethere-radius-md)] border-2 border-[var(--bethere-primary)] bg-transparent px-6 font-bold text-[var(--bethere-primary)]"
            onClick={onCancel}
          >
            Close
          </button>
        </div>
      </div>
    );
  }

  return (
    <form className="admin-form text-left" onSubmit={handleSubmit(onSubmit)}>
      <p className="mb-6 text-sm leading-relaxed text-[var(--muted-foreground)]">
        Forgotten your password? No problem. Enter your email address below and
        we&apos;ll send a confirmation code to your inbox.
      </p>
      <div className="input-group">
        <label htmlFor="forgot-email">Email Address</label>
        <input
          id="forgot-email"
          type="email"
          placeholder="email@address.com"
          autoComplete="email"
          {...register('email', {
            required: 'Required',
            validate: (v) =>
              EMAIL_RE.test(v?.trim() ?? '') || 'Enter a valid email address',
          })}
        />
        {errors.email ? (
          <div className="mt-1 text-sm font-bold text-[var(--destructive)]">
            {errors.email.message}
          </div>
        ) : null}
      </div>
      <button
        type="submit"
        disabled={isSubmitting || resetRequest.isPending}
        className="mt-4 inline-flex min-h-11 w-full items-center justify-center gap-2 rounded-[var(--bethere-radius-md)] bg-[var(--bethere-accent)] px-6 font-bold text-[#121212] shadow-sm transition hover:bg-[var(--bethere-secondary)] disabled:opacity-60"
      >
        <FontAwesomeIcon icon={['fas', 'paper-plane']} />
        Send Reset Link
      </button>
    </form>
  );
}
